import {Injectable} from '@angular/core';
import { Headers, Response, URLSearchParams, RequestOptions } from '@angular/http';
import {HttpAuth} from './http-auth.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import { Event } from '../models/event';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class EventService {

  private eventUrl: string = `${ environment.apiRoot }/event/`;

  constructor(private http: HttpAuth) { }

  public _subject = new Subject<object>();
  public event = this._subject.asObservable();

  public publish () {
    this._subject.next();
  }

  public getEventList(jobId: string, userId: string, startdate: string, enddate: string, page?: number, pagecount?: number, query?: string): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    if (page != null) {
      params.append('page', String(page));
    }

    if (pagecount != null) {
      params.append('pagecount', String(pagecount));
    }

    if (query) {
        params.set('query', query);
    }

    if (jobId != null) {
      params.append('jobid', String(jobId));
    }

    if (userId != null) {
      params.append('userid', String(userId));
    }

    if (startdate) {
      params.append('startdate', startdate);
    }

    if (enddate) {
        params.append('enddate', enddate);
    }

    const options = new RequestOptions({search: params});

    return this.http.get(this.eventUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public putEvent(event:Event): Observable<Event> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey
    });

    return this.http.put(this.eventUrl,event,{headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }

  public postEvent(event:Event): Observable<Event> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey
    });

    return this.http.post(this.eventUrl,event,{headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }

  public deleteEvent(eventID): Observable<Event> {
    const headers = new Headers({
      'Content-Type': 'application/json',
      'X-API-KEY': environment.apiKey,
      'id': eventID
    });

    return this.http.delete(this.eventUrl+"?id="+eventID,{headers: headers})
      .map(this.extractData)
      .catch(this.handleError);
  }

  //noinspection JSMethodCanBeStatic
  private extractData(res: Response) {
    let body = res.json();
    return body.data || {};
  }

  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/services/event.service.ts